import React from 'react';
import { ASSETS } from '@/lib/api';

export function Crest({ size = 'md', className = '' }) {
  const sizes = { sm: 'h-12 w-12', md: 'h-[68px] w-[68px]', lg: 'h-28 w-28', xl: 'h-40 w-40' };
  return (
    <img
      src={ASSETS.shield}
      alt="TRJ Academy crest"
      decoding="async"
      className={`${sizes[size]} object-contain ${className}`}
      data-testid="trj-crest"
    />
  );
}

export function Wordmark({ small = false, light = false }) {
  return (
    <div className="flex items-center gap-1.5" data-testid="trj-wordmark">
      <Crest size={small ? 'sm' : 'md'} />
      <div className="leading-tight">
        <div className={`font-display font-bold tracking-wide ${small ? 'text-lg' : 'text-2xl'} ${light ? 'text-white' : 'text-navy'}`}>
          TRJ ACADEMY<span className="text-gold text-[0.6em] align-super">™</span>
        </div>
        {!small && (
          <div className={`text-[10px] tracking-[0.25em] uppercase mt-0.5 ${light ? 'text-white/70' : 'text-slate-500'}`}>
            Knowledge • Integrity • Leadership
          </div>
        )}
      </div>
    </div>
  );
}
